import FormHelperText from '@material-ui/core/FormHelperText';
import { useFormikContext } from 'formik';
import { useCallback } from 'react';
import { CountryRegionData, RegionDropdown } from 'react-country-region-selector';
import styled from 'styled-components';
const C = {
    DISPLAY_TYPE_FULL: 'full',
    DISPLAY_TYPE_SHORT: 'short',
    REGION_LIST_DELIMITER: '|',
    SINGLE_REGION_DELIMITER: '~',
};
export const getRegions = (country: string) => {
    if (!country) {
        return [];
    }

    let _regions = [];
    CountryRegionData.forEach(function (i) {
        if (i[0] === country) {
            _regions = i;
        }
    });
    if (!_regions) {
        return [];
    }
    const regions = _regions[2];
    return regions.split(C.REGION_LIST_DELIMITER).map((regionPair) => {
        const _regionPair$split = regionPair.split(C.SINGLE_REGION_DELIMITER);
        return { value: _regionPair$split[0], name: _regionPair$split[1] };
    });
};

export const CountryStateDropdown = ({ country, name }) => {
    const formik = useFormikContext<any>();
    const state = formik.getFieldMeta<string>(name);
    const stateMeta = formik.getFieldHelpers<string>(name);

    const handleChange = useCallback(
        (val) => {
            stateMeta.setValue(val);
        },
        [stateMeta],
    );
    const prop = {
        blacklist: {
            US: [
                'Armed Forces Americas',
                'Armed Forces Pacific',
                'Armed Forces Europe, Canada, Africa and Middle East',
            ],
        },
        blankOptionLabel: 'No country selected',
    };

    return (
        <>
            <StyledRegionDropdown
                country={country}
                value={state.value}
                onChange={handleChange}
                valueType={'short'}
                {...prop}
            />
            {state.touched && state.error ? <FormHelperText error={true}>{state.error}</FormHelperText> : null}
        </>
    );
};

const StyledRegionDropdown = styled(RegionDropdown)`
    && {
        width: 100%;
        max-width: 100%;
        max-height: 56px;
        background-color: #fff;
        position: relative;
        border-radius: 4px;
        color: rgba(0, 0, 0, 0.87);
        cursor: text;
        display: inline-flex;
        position: relative;
        font-size: 1rem;
        box-sizing: border-box;
        align-items: center;
        font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
        font-weight: 400;
        line-height: 1.1876em;
        letter-spacing: 0.00938em;
        border: solid 1px rgba(0, 0, 0, 0.23);
        padding: 8.5px 14px;
        ::placeholder {
            color: rgba(0, 0, 0, 0.35);
        }
        &:hover {
            border: solid 1px rgba(0, 0, 0, 0.23);
        }
        &:focus-visible {
            outline-color: #e4002b;
        }
        & option {
            background-color: #fff;
            &:hover,
            &:focus {
                background-color: #ccc;
            }
        }
    }
`;
